import { useEffect, useState } from "react";
import OrderRequestCard from "./OrderRequestCard";
import BoxInfoCollapse from "./BoxInfoCollapse";
import { OrderRequestState } from "../../types/OrderRequestTypes";
import { Box } from "@mui/material";

export default function AssetsPastList({ orderRequests, page, result }) {
  const [list, setList] = useState(orderRequests);
  const [indexToShowBox, setIindexToShowBox] = useState(null);
  const [infoBoxIsNotInPlaced, setInfoBoxIsNotInPlaced] = useState(true);
  useEffect(() => {
    if (infoBoxIsNotInPlaced) {
      for (let i = 0; i < orderRequests.length; i++) {
        if (
          orderRequests[i].state == OrderRequestState.APPROVED ||
          orderRequests[i].state == OrderRequestState.DELETED ||
          orderRequests[i].state == OrderRequestState.REFUNDED
        ) {
          setInfoBoxIsNotInPlaced(false);
          setIindexToShowBox(i + page * 20);
          return;
        }
      }
    }
    setList(orderRequests);
  }, [orderRequests]);

  return (
    <>
      {list &&
        list.length > 0 &&
        list.map((orderRequest, index) => {
          return (
            <Box
              key={orderRequest.id}
              sx={{
                width: "100%",
                "&:last-child": {
                  borderBottom: "none",
                },
                borderBottom: (theme) => `1px solid ${theme.palette.grey[6]}`,
              }}
            >
              {index == indexToShowBox && <BoxInfoCollapse result={result} />}
              <OrderRequestCard
                key={orderRequest.id}
                orderRequest={orderRequest}
              />
            </Box>
          );
        })}
    </>
  );
}
